<template>
    <PortalAuth>
        <div class="d-flex align-items-center min-vh-100">
            <CContainer fluid>
                <CRow class="justify-content-center">
                    <CCol lg="6" md="8" sm="10" style="max-width: 500px">
                        <CCard class="mx-4 mb-0">
                            <CCardBody class="p-4">
                                <CForm @submit.prevent="onSubmit">
                                    <h2 class="mb-4" style="text-align:center">Password recovery</h2>
                                    <CInput
                                        v-model="email"
                                        placeholder="Email"
                                        autocomplete="email"
                                        name="email"
                                        type="email"
                                        :readonly="linkWasSent"
                                    >
                                        <template #prepend-content>
                                            <CIcon name="cilEnvelopeOpen"/>
                                        </template>
                                    </CInput>
                                    <FormErrors :errors="errors"/>
                                    <div v-if="!linkWasSent" class="mt-4" style="text-align:center">
                                        <CButton type="submit" color="success" :disabled="this.graphqlLoadingFlag">Send link for changing password</CButton>
                                    </div>
                                    <p class="mt-3" v-if="linkWasSent">The link to password change was sent to this email in case if account with such
                                        email exists</p>
                                </CForm>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </div>
    </PortalAuth>
</template>

<script>
    import {
        getProcessedAuthResponseErrorsFlat,
        getSendPasswordResetEmailMutation
    } from '@/scripts/auth-utils'
    import {onSubmitHandler} from '@/scripts/forms-utils'

    import PortalAuth from '@/components/layouts/PortalAuth'
    import FormErrors from '@/components/FormErrors'

    export default {
        components: {PortalAuth, FormErrors},
        data() {
            return {
                errors: [],
                graphqlLoadingFlag: false,
                linkWasSent: false,
                email: ''
            }
        },
        methods: {
            async onSubmit() {
                let mutation = getSendPasswordResetEmailMutation(this.email)
                this.linkWasSent = false
                await onSubmitHandler(this, mutation,
                    {
                        setErrorsF: (errors, scope) => scope.errors = getProcessedAuthResponseErrorsFlat(errors),
                        onSuccessF: (res, scope) => scope.linkWasSent = true
                    })
            }
        }
    }
</script>
